import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  viewerCount: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    zIndex: 1000,
    top: theme.spacing(2),
    left: theme.spacing(2),
    '&$popoutMode': {
      display: 'none'
    }
  },
  popoutMode: {},
  viewCountTypography: {
    fontFamily: 'Oswald, Roboto, sans-serif',
    fontSize: 20,
    fontWeight: 300,
    color: 'white'
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/ViewerCount/styles.js